if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        const submitButtonWasDisabled = this.submitButton.disabled;

        // Tracks whether Customily has confirmed readiness (or there is no Customily
        // context to wait for). Gates both the native-ATC unlock and the submit guard
        // so nothing is added to cart before #customily-cart-btn is truly ready.
        this.customilyReleased = false;

        const enableSubmitButton = () => {
          this.customilyReleased = true;
          if (submitButtonWasDisabled) return;
          this.submitButton.disabled = false;
          this.submitButton.removeAttribute('aria-disabled');
        };

        if (!submitButtonWasDisabled) {
          const customilyGuard = window.AlmaGemsCustomilyGuard;
          const hasCustomilyGuard =
            customilyGuard && customilyGuard.ready && typeof customilyGuard.ready.then === 'function';

          if (!hasCustomilyGuard) {
            // No Customily on this page — nothing to gate on, leave ATC enabled.
            this.customilyReleased = true;
          } else {
            // Customily present: lock the native ATC until the guard confirms the product
            // is non-custom OR #customily-cart-btn is truly ready (guard.uiRendered).
            // No hard timeout force-unlock — readiness is the only release signal.
            this.submitButton.disabled = true;
            this.submitButton.setAttribute('aria-disabled', true);

            customilyGuard.ready
              .then((result) => {
                if (result && result.active === false) {
                  enableSubmitButton();
                  return;
                }
                var releaseSignal = customilyGuard.uiRendered || customilyGuard.scriptsReady;
                if (releaseSignal && typeof releaseSignal.then === 'function') {
                  releaseSignal.then(enableSubmitButton);
                } else {
                  enableSubmitButton();
                }
              })
              .catch(enableSubmitButton);
          }
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const customilyGuard = window.AlmaGemsCustomilyGuard;
        if (
          customilyGuard &&
          typeof customilyGuard.isGetMyDesignPending === 'function' &&
          customilyGuard.isGetMyDesignPending()
        ) {
          if (typeof customilyGuard.notifyGetMyDesignRequired === 'function') {
            customilyGuard.notifyGetMyDesignRequired();
          }
          return;
        }

        // Belt-and-suspenders: never add to cart before Customily confirmed its cart
        // button is ready (covers double-click / Enter / any submit that slips past the
        // disabled state). Only gates when a #customily-cart-btn exists on the page.
        if (!this.customilyReleased && document.getElementById('customily-cart-btn')) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const finalFormData = new FormData();
        for (const [key, value] of formData.entries()) {
          if (key === 'properties[_Upload Photo Here]') {
            finalFormData.append('properties[Upload Photo Here]', value);
          } else {
            finalFormData.append(key, value);
          }
        }
        config.body = finalFormData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              if (typeof window.trackAmazonAddToCart === 'function') {
                window.trackAmazonAddToCart();
              }
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof window.trackAmazonAddToCart === 'function') {
              window.trackAmazonAddToCart();
            }
            this.error = false;
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
